module.exports = __webpack_public_path__ + "img/logo.97fede99.png";